import React, { createContext, useContext, useState, useEffect } from "react";
import { translations } from "@/i18n/translations";

const LangContext = createContext(null);

export function LangProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("yosi_lang") || "es");
  useEffect(() => { localStorage.setItem("yosi_lang", lang); }, [lang]);
  const t = (path) => {
    const parts = path.split(".");
    let cur = translations[lang];
    for (const p of parts) {
      if (cur == null) return path;
      cur = cur[p];
    }
    return cur ?? path;
  };
  return (
    <LangContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LangContext.Provider>
  );
}

export const useLang = () => {
  const ctx = useContext(LangContext);
  if (!ctx) throw new Error("useLang must be inside LangProvider");
  return ctx;
};
